import Result from "@/core/common/Result";
import { IDefaultInsightsIAResponse } from "../../../views/agenteDeDRE/services/InsightsAIDreGateway";

export type IDiaRelatorioMensal = 10 | 15 | 20;

export type ISalvarInsightConfiguracaoResponse = {
  success: boolean;
  message: string;
};

export type ISalvarDiaDoMesParams = {
  diaDoMes: IDiaRelatorioMensal;
};

export type ISalvarTelefoneWhatsappParams = {
  telefoneWhatsapp: string;
  nome: string;
};

export type TConfigurarInsightsIARequest = {
  idModeloDRE: string;
  diaGeracaoRelatorio: number;
  AgenteLigado: boolean;
  WhatsappLigado: boolean;
};

export type TLimparRelatorioAgenteDRERequest = {
  DataDeCompetencia: string;
};

export type TGerarRelatorioAgenteDRERequest = {
  idModeloDRE: string;
  dataDeCompetencia: string;
};

export type IListarContatatosResponse = {
  nome: string;
  usuarioId: string;
  cadastradoId: string;
  telefone: string;
  status: string;
  tipoRelatorios: string[];
};

export type ISalvarContatoParams = {
  isWhatsApp: boolean;
  telefone: string;
};

export type ISalvarContatoResponse = {
  nome: string;
  usuarioId?: string;
  cadastradoId?: string;
  telefone: string;
  status: string;
  tipoRelatorios: string[];
};

export interface InsightConfiguracaoGateway {
  configurar(
    payload: TConfigurarInsightsIARequest
  ): Promise<Result<ISalvarInsightConfiguracaoResponse>>;
  limparRelatorio(
    payload: TLimparRelatorioAgenteDRERequest
  ): Promise<Result<boolean>>;
  gerarRelatorio(
    payload: TGerarRelatorioAgenteDRERequest
  ): Promise<Result<boolean>>;
  listarContatatos(): Promise<Result<IListarContatatosResponse[]>>;
  salvarContato(
    payload: ISalvarContatoParams
  ): Promise<Result<IDefaultInsightsIAResponse<ISalvarContatoResponse>>>;
}

export const InsightConfiguracaoGatewayDi = Symbol.for(
  "InsightConfiguracaoGateway"
);
